import React, { useCallback, FC } from 'react';

import { fireLogEvent } from 'services/firebase';

import { Button } from './Button';
import * as T from './interfaces';

export const Container: FC<T.IContainer> = ({
  children,
  onClick,
  logEvent,
  variant = 'primary',
  font = 'regular',
  margin = 'zeroMargin',
  loading,
  type = 'button',
  id,
  disabled,
  icon,
  ...rest
}) => {
  const handleClick = useCallback(
    event => {
      !!logEvent && fireLogEvent(logEvent.logName, logEvent.params);
      onClick(event);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [onClick, logEvent],
  );

  return (
    <Button
      {...rest}
      id={`button@${id}`}
      data-testid={`button@${id}`}
      variant={variant}
      margin={margin}
      type={type}
      onClick={handleClick}
      disabled={disabled || loading}
      loading={loading}
      icon={icon}
    >
      {children}
    </Button>
  );
};
